import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import MainLayout from '../../../layout/main-layout';
import UIDropdown from '../../../components/ui/ui-dropdown';
import { APP_API_URL } from '../../../utils';

const REASONS = [
  { label: 'Cassé', value: 'casse' },
  { label: 'Gâté', value: 'gate' },
];

export default function AddDamagedGood() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({ label: 'Sélectionner un produit', value: '' });
  const [selectedReason, setSelectedReason] = useState(REASONS[0]);
  const [quantity, setQuantity] = useState('');
  const [note, setNote] = useState('');
  const [isLoading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${APP_API_URL}/damaged-goods/catalog`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProducts(response.data.data || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const unit = selectedProduct.unit || 'unité';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedProduct.value || !quantity || Number(quantity) <= 0) {
      Swal.fire({ icon: 'error', text: 'Choisissez un produit et une quantité.' });
      return;
    }
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${APP_API_URL}/damaged-goods`, {
        variant_id: selectedProduct.value,
        quantity: Number(quantity),
        reason: selectedReason.value,
        note,
        user_id: user?.id,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await Swal.fire({
        icon: 'success',
        title: 'Enregistré',
        text: 'Le stock normal a été diminué. L’article est disponible à la vente cassée.',
        timer: 1800,
        showConfirmButton: false,
      });
      navigate('/admin/damaged-goods');
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error.response?.data?.message || 'Enregistrement impossible.',
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <MainLayout>
      <div className="duo-page">
        <div className="duo-hero duo-hero--compact mb-3">
          <p className="duo-hero-sub mb-1">Hors carrelage</p>
          <h1 className="duo-hero-title">Déclarer un article cassé ou gâté</h1>
          <p className="duo-hero-sub mt-2 mb-0">
            Sanitaire, robinetterie, meuble et accessoires. Le carrelage reste dans Carreaux cassés.
          </p>
        </div>
        <section className="duo-panel duo-panel--form">
          <form onSubmit={handleSubmit} className="duo-form-stack">
            <div>
              <label className="duo-form-label">Produit en stock</label>
              <UIDropdown
                options={products.map((product) => ({
                  label: `${product.name} (${product.sku || 'sans réf.'}) — ${product.quantity} ${product.unit || ''}`.trim(),
                  value: product.id,
                  unit: product.unit,
                }))}
                selectedOption={selectedProduct}
                onSelect={setSelectedProduct}
                enableSearch
              />
              <p className="small text-muted mt-1 mb-0">
                {isLoading
                  ? 'Chargement du catalogue…'
                  : `${products.length} produit${products.length > 1 ? 's' : ''} hors carrelage`}
              </p>
            </div>
            <div className="duo-form-row duo-form-row--2">
              <div>
                <label className="duo-form-label">Motif</label>
                <UIDropdown
                  options={REASONS}
                  selectedOption={selectedReason}
                  onSelect={setSelectedReason}
                />
              </div>
              <div>
                <label className="duo-form-label">Quantité ({unit})</label>
                <input
                  type="number"
                  className="duo-input"
                  min="0.01"
                  step="0.01"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </div>
            </div>
            <div>
              <label className="duo-form-label">Note</label>
              <textarea
                className="duo-input"
                rows={3}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Optionnel"
              />
            </div>
            <div className="d-flex justify-content-end gap-2">
              <Link to="/admin/damaged-goods" className="duo-btn duo-btn--ghost">Retour</Link>
              <button type="submit" className="duo-btn duo-btn--primary" disabled={saving || isLoading}>
                {saving ? 'Enregistrement…' : 'Enregistrer'}
              </button>
            </div>
          </form>
        </section>
      </div>
    </MainLayout>
  );
}
